import { createAction } from "@ngrx/store";

export const recentAnnouncementsTilesInitialized = createAction(
  "[Recent Announcements Tiles]: Initialized",
);
